import React from 'react'

// form fields
// import AppFormikInput from 'utlis/helpers/forms/AppFormikInput'

export default function Taxes(props) {
    // props
    const {
        // formik
    } = props


    return (
        <React.Fragment>
            {/* page border box 2 */}
            <div className="page-border-box2">
                <div className="pbb2-inner">
                    {/* heading */}
                    <p className="box-heading st-fs-18 st-fw-600 st-text-color mb-2">Taxes</p>

                    <p className="st-fs-13 st-text-color2">
                        Taxes for all of your products are calculated automatically based on the customer location.
                    </p>
                </div>
            </div>
        </React.Fragment>
    )
}
